import { createContext, useContext, useEffect, useState } from "react";
import { supabaseClient } from "../components/supabaseClient";

const UserInputContext = createContext({});

export const useUserInput = () => useContext(UserInputContext);

const UserInputProvider = ({ children }: { children: React.ReactNode }) => {
  const [userInputs, setUserInputs] = useState<any[]>([]);
  const [errorMsg, setErrorMsg] = useState("");
  const [msg, setMsg] = useState("");
  const addMortgageInput = async (mortgageInput: any) => {
    const { data, error } = await supabaseClient.from("UserInputs").insert(mortgageInput).select();
    if (error) {
      setErrorMsg(error.message);
    }
    if (data) {
      setUserInputs((prevUserInputs: any[]) => [...prevUserInputs, data[0]]);
      setMsg("User Input Successfully");
    }
    console.log(errorMsg)
    console.log(msg)
  };

  const fetchAll = async () => {
    const { data, error } = await supabaseClient.from("UserInputs").select();
    if (data) setUserInputs(data);
    if (error) setErrorMsg("Error in Fetching UserInputs");
  };

  return (
    <UserInputContext.Provider
      value={{
        userInputs,
        msg,
        setMsg,
        errorMsg,
        setErrorMsg,
        addMortgageInput,
        fetchAll
      }}>
      {children}
    </UserInputContext.Provider>
  );
};

export default UserInputProvider;